export const CHARTS_DATA = 'CHARTS_DATA';
